const KEY = 'nt:auth:redirect';

export function saveRedirect(path: string): void {
  if (path && path !== '/login') {
    localStorage.setItem(KEY, path);
  }
}

export function consumeRedirect(): string | null {
  const path = localStorage.getItem(KEY);
  if (path) localStorage.removeItem(KEY);
  return path;
}
